export default {
	props: {
		label: {type:String, default:'Label',},
		minVal: {type:Number, default:0,},
		maxVal: {type:Number, default:1,},
		value: {type:Number, default:0,},
	},
	data(){
		return {
			validationClass: '',
		}
	},
	watch: {
		value:{
			//immediate: true,
			handler(v){
				if(this.validationClass){
					this.$nextTick(()=>{ this.validate(); });
				}
			},
		},
	},
	computed:{
		innerValue:{
			get(){
				return this.value;
			},
			set(v){
				let newVal = parseInt(v);
				if(isNaN(newVal) || newVal<this.minVal){
					newVal = this.minVal;
				}
				else if(newVal>this.maxVal){
					newVal = this.maxVal;
				}
				this.$emit('input', newVal);
			},
		},
		options(){
			const options = [];
			for(let i=this.minVal; i<=this.maxVal; i++){
				options.push({label:this.$tc('childrenAge', i), value: i});
			}
			return options;
		},
		isValid(){
			return this.value>=this.minVal && this.value<=this.maxVal;
		}
	},
	methods: {
		validate(){
			this.validationClass = this.isValid ? '' : 'invalid';
			return this.isValid;
		}
	},
	template: `
<div class="qit-child-age">
	<div class="label">{{label}}</div>
	<qit-select
		:class="['v4', validationClass]"
		:label="$t('ctrSelectChildAgeLbl')" :label-value="-1" label-disabled
		:options="options"
		v-model="innerValue"
	/>
</div>
`,
}
